import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';
import Fade from 'embla-carousel-fade';
import ClassNames from 'embla-carousel-class-names';
import Autoplay from 'embla-carousel-autoplay';

export function handleSliders():void {
	const sections:NodeListOf<HTMLElement> = document.querySelectorAll('.section--problem-solution')

	sections?.forEach(section => {
		const gallerySliderWrapper = section.querySelector('.problem--solution-gallery') as HTMLElement;
		const gallerySliderContainer = section.querySelector('.problem--solution-gallery .embla__viewport') as HTMLElement;
		const titleSliderContainer = section.querySelector('.problem--solution-titles .embla__viewport') as HTMLElement;

		if (!gallerySliderContainer || !titleSliderContainer) return;

		const delay = parseInt((gallerySliderWrapper.getAttribute('data-delay') ?? '4'), 10)

		const autoplayOptions = {
			delay: delay * 1000,
			stopOnInteraction: false,
			stopOnMouseEnter: false
		}

		const autoplayPlugin = Autoplay(autoplayOptions)

		const gallerySlider: EmblaCarouselType = EmblaCarousel(gallerySliderContainer, {
			loop: true,
			duration: 30
		}, [Fade(), ClassNames(), autoplayPlugin])

		const titleSlider: EmblaCarouselType = EmblaCarousel(titleSliderContainer, {
			axis: 'y',
			loop: true,
			align: 'center',
			slidesToScroll: 1,
			duration: 20
		}, [ClassNames()])

		let isSyncing = false
		let isUserInteraction = false

		const syncGalleryToTitle = () => {
			if (isSyncing) return
			isSyncing = true
			const selectedIndex = titleSlider.selectedScrollSnap()
			gallerySlider.scrollTo(selectedIndex, false)
			setTimeout(() => {
				isSyncing = false
			}, 50)
		}

		const syncTitleToGallery = () => {
			if (isSyncing) return
			isSyncing = true
			const selectedIndex = gallerySlider.selectedScrollSnap()
			titleSlider.scrollTo(selectedIndex, false)
			setTimeout(() => {
				isSyncing = false
			}, 50)
		}

		const titleSlides = titleSliderContainer.querySelectorAll('.embla__slide')
		titleSlides.forEach((slide, index) => {
			slide.addEventListener('click', () => {
				if (isSyncing) return
				isUserInteraction = true
				isSyncing = true

				gallerySlider.scrollTo(index, false)
				titleSlider.scrollTo(index, false)

				autoplayPlugin.reset()
				setTimeout(() => {
					isSyncing = false
					isUserInteraction = false
				}, 50)
			})
		})

		gallerySlider.on('pointerDown', () => {
			isUserInteraction = true
		})

		titleSlider.on('pointerDown', () => {
			isUserInteraction = true
		})

		titleSlider.on('select', () => {
			if (isUserInteraction) {
				autoplayPlugin.reset()
				isUserInteraction = false
			}
			syncGalleryToTitle()
		})

		gallerySlider.on('select', () => {
			if (isUserInteraction) {
				autoplayPlugin.reset()
				isUserInteraction = false
			}
			syncTitleToGallery()
		})

		const initialIndex = gallerySlider.selectedScrollSnap()
		titleSlider.scrollTo(initialIndex, true)
	})
}